
import { defineComponent, getCurrentInstance, computed } from 'vue';
import { sendLog } from '@/common/radar';

export default defineComponent({
    components: {},
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        isUserCollect: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['init'],
    setup(props, ctx) {
        const { proxy } = getCurrentInstance() as { proxy: any };
        const handleGuessCard = (item: string) => {
            sendLog({
                type: 'click',
                name: 'GUESS_YOU_MAY_LIKE',
                value: {
                    result: item,
                },
            });
            proxy.$router.push({ path: `/discover/${item}`, params: { refresh: true } });
            setTimeout(() => {
                ctx.emit('init');
            }, 0);
        };

        const list = computed(() => {
            return props.data.map((item: any) => {
                return decodeURIComponent(item).replace(/(-)/g, ' ');
            });
        });

        return {
            handleGuessCard,
            list,
        };
    },
});
